import React, { useContext, useEffect } from 'react'
import styled, { css } from 'styled-components'

import InputRange from '../InputRange'
import MessagesContext from '../../context/MessagesContext'

const StyledWrapper = styled.div`
  background-color: #04162b;
  overflow: hidden;
  width: 100%;

  ${props =>
    props.isSurvey &&
    css`
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    `}

  ${props =>
    !props.isSurvey &&
    css`
      text-align: center;
    `}

  ${({ isSurvey, theme }) => !isSurvey && theme.media.desktop} {
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
  }
`

const StyledSection = styled.div`
  margin: 0 0 2px;
  padding: ${props => (props.isSurvey ? '0 0 60px' : '16px 20px 60px')};

  h4 {
    color: #4e5d78 !important;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.71;
    margin: 0 0 8px;
    padding: 0 10px;
  }

  ${({ theme }) => theme.media.desktop} {
    padding: ${props => (props.isSurvey ? '0 32px 60px' : '16px 32px 60px')};
  }
`

const StyledValue = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-size: 18px;
  font-weight: 300;
  line-height: 1.29;
  margin: 0 10px 20px;

  span {
    color: #4e5d78;
    font-size: 16px;
    font-weight: normal;
    line-height: 1.31;
  }
`

const emailValues = [
  0,
  10000,
  20000,
  30000,
  40000,
  50000,
  75000,
  100000,
  150000,
  200000,
  250000,
  300000,
  400000,
  475000,
  500000,
  750000,
  1000000,
  1500000,
  2000000,
  2500000,
  3000000,
  3500000,
  4000000,
  4500000,
  5000000,
]

// Keep in descending order
const TIER_BREAKS = [
  { value: 250000, name: 'Scale' },
  { value: 100000, name: 'Growth' },
  { value: 50000, name: 'Foundation' },
  { value: 0, name: 'Trial' },
]

/**
 * Flatten options into single array of destrutured plan options, calculate
 * plan prices, and return plan with best price
 */
const findBestPlan = (plans, messages) => {
  // Find the recommened plan tier, by number of messages and map
  const recommendedTier = TIER_BREAKS.find(tier => tier.value <= messages)
  const tierName = recommendedTier ? recommendedTier.name : plans[0].name

  // Return largest plan option that is less then requested number of messages
  const recommendedPlan = plans.find(plan => plan.name === tierName)

  // Get plan options of the found tier
  const options = [ ...recommendedPlan.options ]
  
  // Sort options in descending order, by messages
  options.sort((a, b) => (a.messages > b.messages ? -1 : 1))

  const recommendedOption =
    // Return the first (largest) option with less or equal messages
    options.find(plan => plan.messages <= messages) ||
    // Or default to the very first plan
    plans[0].options[0]

  recommendedOption.planId = recommendedPlan.id

  return recommendedOption
}

const Estimation = ({
  isSurvey = false,
  setRecommendedPlan = () => null,
  onRangeChange = () => null,
  recommendedPlan,
  plans,
}) => {
  const { messages, setMessages } = useContext(MessagesContext)
  const rangeInitialIndex = emailValues.findIndex(i => i === messages)

  useEffect(() => {
    const plan = findBestPlan(plans, messages)
    setRecommendedPlan(plan)
    onRangeChange(plan.name, messages, true)
  }, [plans, messages, recommendedPlan, setRecommendedPlan, onRangeChange])

  return (
    <StyledWrapper isSurvey={isSurvey}>
      <StyledSection isSurvey={isSurvey}>
        {!isSurvey && <h4>How many emails do you plan to send per month?</h4>}
        <StyledValue>{messages.toLocaleString()}</StyledValue>
        <InputRange
          singleColor
          onChange={setMessages}
          initialValue={rangeInitialIndex}
          values={emailValues}
        />
      </StyledSection>
    </StyledWrapper>
  )
}

export default Estimation
